/* eslint-disable */
import { BaseResponse } from "../models/response/BaseResponse";

export default async function responseHandler<T>(response: Response) {
  return response.json().then((baseResponse: BaseResponse<T>) => baseResponse.data);
}